import React from "react";
import { useNavigate } from "react-router-dom";
import "./Podpora.css";

import {
    TbArrowLeft,
    TbHeadset,
    TbMail,
    TbPhone,
    TbHelpCircle,
    TbClockHour4,
    TbShieldCheck,
} from "react-icons/tb";

export default function Podpora() {
    const navigate = useNavigate();

    return (
        <div className="podpora-page">
            <section className="podpora-page__hero">
                <div className="podpora-page__heroContent">
                    <div className="podpora-page__badge">
                        <TbHeadset aria-hidden="true" />
                        <span>Podpora</span>
                    </div>

                    <h1 className="podpora-page__title">Pomoč in podpora</h1>

                    <p className="podpora-page__subtitle">
                        Tukaj najdete hiter dostop do kontaktnih podatkov, osnovnih
                        informacij in najpogostejših odgovorov. Stran je enostavna,
                        pregledna in usklajena z vašim obstoječim izgledom.
                    </p>
                </div>

                <button
                    type="button"
                    className="podpora-page__backButton"
                    onClick={() => navigate("/profil")}
                    title="Nazaj na profil"
                >
                    <span className="podpora-page__backIcon" aria-hidden="true">
                        <TbArrowLeft />
                    </span>
                    <span className="podpora-page__backText">Nazaj</span>
                </button>
            </section>

            <section className="podpora-page__grid">
                <article className="podpora-page__card podpora-page__card--accent">
                    <div className="podpora-page__cardIcon" aria-hidden="true">
                        <TbMail />
                    </div>
                    <h2 className="podpora-page__cardTitle">E-pošta</h2>
                    <p className="podpora-page__cardText">
                        Za vprašanja, težave ali dodatna pojasnila nam pišite na spodnji
                        naslov.
                    </p>
                    <a
                        className="podpora-page__cardLink"
                        href="mailto:podpora@primer.si"
                    >
                        podpora@primer.si
                    </a>
                </article>

                <article className="podpora-page__card">
                    <div className="podpora-page__cardIcon" aria-hidden="true">
                        <TbPhone />
                    </div>
                    <h2 className="podpora-page__cardTitle">Telefon</h2>
                    <p className="podpora-page__cardText">
                        Za hitrejšo pomoč nas lahko pokličete v delovnem času.
                    </p>
                    <a className="podpora-page__cardLink" href="tel:+38640123456">
                        +386 40 123 456
                    </a>
                </article>

                <article className="podpora-page__card">
                    <div className="podpora-page__cardIcon" aria-hidden="true">
                        <TbClockHour4 />
                    </div>
                    <h2 className="podpora-page__cardTitle">Delovni čas</h2>
                    <p className="podpora-page__cardText">
                        Dosegljivi smo od ponedeljka do petka.
                    </p>
                    <div className="podpora-page__cardMeta">08:00 – 16:00</div>
                </article>

                <article className="podpora-page__card">
                    <div className="podpora-page__cardIcon" aria-hidden="true">
                        <TbShieldCheck />
                    </div>
                    <h2 className="podpora-page__cardTitle">Varna obravnava</h2>
                    <p className="podpora-page__cardText">
                        Vaše podatke obravnavamo zaupno in pregledno skladno z internimi
                        postopki.
                    </p>
                    <div className="podpora-page__cardMeta">Zaupno in varno</div>
                </article>
            </section>

            <section className="podpora-page__section">
                <div className="podpora-page__sectionHead">
                    <TbHelpCircle aria-hidden="true" />
                    <h2 className="podpora-page__sectionTitle">Pogosta vprašanja</h2>
                </div>

                <div className="podpora-page__faq">
                    <details className="podpora-page__faqItem">
                        <summary className="podpora-page__faqSummary">
                            Kako prijavim tehnično težavo?
                        </summary>
                        <p className="podpora-page__faqText">
                            Pošljite opis težave na e-pošto podpore. Dodajte čim več
                            podatkov: na kateri strani se napaka pojavi, kaj ste kliknili
                            in po možnosti posnetek zaslona.
                        </p>
                    </details>

                    <details className="podpora-page__faqItem">
                        <summary className="podpora-page__faqSummary">
                            Kako hitro lahko pričakujem odgovor?
                        </summary>
                        <p className="podpora-page__faqText">
                            Običajno odgovorimo v najkrajšem možnem času znotraj delovnega
                            časa. Pri zahtevnejših primerih lahko obdelava traja nekoliko
                            dlje.
                        </p>
                    </details>

                    <details className="podpora-page__faqItem">
                        <summary className="podpora-page__faqSummary">
                            Ali lahko vprašanje pošljem tudi po telefonu?
                        </summary>
                        <p className="podpora-page__faqText">
                            Da. Za nujna vprašanja je telefon najhitrejša možnost, za bolj
                            podrobne zadeve pa priporočamo e-pošto.
                        </p>
                    </details>
                </div>
            </section>
        </div>
    );
}